(function () {
    'use strict';
    angular.module('mso.registration')
        .factory('RegisterService', RegisterService);

    RegisterService.$inject = ['enums', 'RegisterDataAccessService', '$q', '$exceptionHandler'];
    function RegisterService(enums, RegisterDataAccessService, $q, $exceptionHandler) {

        return {
            prepareUserRegistration: prepareUserRegistration,
            getSelectedMortgageClubs: getSelectedMortgageClubs,
            getFirmEmail: getFirmEmail,
            getIsSentNotifications: getIsSentNotifications
        };

        // Validates the user-supplied data and prepares it for registration
        function prepareUserRegistration(form, vm) {
            // Clear any server-side validation errors so it rechecks each time
            form.emailAddress.$setValidity("duplicate", true);

            if (vm.hasMarketingPreferenceEnabled && vm.user.hasMarketingPreference == undefined) {
                vm.user.hasMarketingPreference = false;
            }

            if (!vm.roleAcceptableForAdminNotifications) {
                vm.user.areAdminsSentNotifications = false;
            }
            else {
                vm.user.areAdminsSentNotifications = vm.areAdminsSentNotifications;
            }

            if (vm.areAdminsSentNotifications && vm.firm.isSentNotifications) {
                vm.user.areAdminsSentNotifications = false;
            }

            if (vm.parameters.p6213.toLowerCase() === 'true' && vm.firm.intermediaryType === vm.enums.RDIntermediaryType.directlyAuthorised && vm.isNewUserFirmAllowed && vm.firmIsManual) {
                form.bankSortCode.$setValidity("bankAccountValidationFailure", true);
                form.bankAccountNumber.$setValidity("bankAccountValidationFailure", true);
                vm.bankAccountNumberValidationFailureId = 0;
                vm.bankSortCodeValidationFailureId = 0;
            }

            if (vm.isNewUserFirmAllowed && vm.firmIsManual) {
                if (!validateAddressViewmodel(vm.firmAddressFlagsViewModel)) {
                    setAddressRequiredValidity(form);
                }
                else {
                    form.$setValidity('address-required', true);
                }
                // Check manually entered trading address
                if (!validateAddressViewmodel(vm.tradingAddressAddressFlagsViewModel)) {
                    setAddressRequiredValidity(form);
                }
                else {
                    form.$setValidity('address-required', true);
                }
            }

            form.$setValidity('firm-required', true);
            if (!vm.isNewUserFirmAllowed && vm.firmIsManual) {
                form.$setValidity('firm-required', false);
            }

            // Clear any bank address validation errors as we will recheck during bank validation
            form.$setValidity('address-required', true);

            //reset firm validity
            form.firmFcaNumber.$setValidity("duplicatefirm", true);

            // Check Mortgage clubs validity
            vm.mortgageClubsMissing = false;
            if (vm.firm.intermediaryType === vm.enums.RDIntermediaryType.directlyAuthorised && vm.isNewUserFirmAllowed && vm.firmIsManual) {
                var selectedMortgageClubs = getSelectedMortgageClubs(vm);
                if (selectedMortgageClubs == null || selectedMortgageClubs.length == 0) {
                    vm.mortgageClubsMissing = true;
                }
            }

            // FCA Number is already a Mortgage club
            vm.existsAsMortgageClub = false;
            form.networkFcaNumber.$setValidity('mortgage-club-exists', true);
            if (vm.firm.intermediaryType === vm.enums.RDIntermediaryType.appointedRepresentative && vm.isNewUserFirmAllowed && vm.firmIsManual) {
                if (vm.allMortgageClubs.some(function (m) {
                    return m.registrationNumber == vm.firm.networkFcaNumber;
                }
                )) {
                    vm.existsAsMortgageClub = true;
                    form.networkFcaNumber.$setValidity('mortgage-club-exists', false);
                }
            }

            // Check principal validity
            vm.principalFirmMissing = false;

            if (vm.firm.intermediaryType === vm.enums.RDIntermediaryType.appointedRepresentative && vm.isNewUserFirmAllowed && vm.firmIsManual
                && vm.principalFCADropDownRequired && vm.principalFCARequired) {
                if ((vm.selectedPrincipalFirm == null) || (vm.selectedPrincipalFirm.fcaNumber == null || vm.selectedPrincipalFirm.fcaNumber.length == 0)) {
                    vm.principalFirmMissing = true;
                }
            }

            if (vm.firm.intermediaryType === vm.enums.RDIntermediaryType.appointedRepresentative && vm.isNewUserFirmAllowed && vm.firmIsManual
                && vm.principalFCADropDownRequired && !vm.principalFCARequired && !vm.principalFirmMissing && vm.selectedPrincipalFirm != null && vm.selectedPrincipalFirm != "") {
                vm.principalFirmMissing = true;
                angular.forEach(vm.principalFirms, function (value) {
                    if (value.fcaNumber == vm.selectedPrincipalFirm.fcaNumber) {
                        vm.principalFirmMissing = false;
                    }
                })
            }

            form.intermediaryUserRole0.$setValidity('role-required', true);
            if (!vm.validateRoleSelected(form)) {
                form.intermediaryUserRole0.$setValidity('role-required', false);
            }

            var deferred = $q.defer();
            // If the form is invalid OR
            // if the firm is not manually entered and the user has not selected a firm - they
            // could have "found" a firm but not clicked Select yet. Then block the form from
            // submitting
            if (form.$invalid || (!vm.findFirmSelected && !vm.firmIsManual)) {
                deferred.reject();
                return deferred.promise;
            }

            var user = populateUser(vm);

            if (vm.parameters.p6213.toLowerCase() === 'true' && vm.firm.intermediaryType === enums.RDIntermediaryType.directlyAuthorised) {
                user.firm.bankDetails = populateBankDetails(vm);
            }

            if (vm.tradingAddress.id || vm.tradingAddress.name) {
                user.tradingAddress = populateTradingAddress(vm)
            }

            // Validate that
            // - the user email address does not already exist
            // - Validate whether firm is already registered according to user declaration

            var validationPromises = [];
           
            if (vm.isNewUserFirmAllowed && !vm.findFirmSelected) {
                validationPromises.push($q.when(validateFirm(user.firm.fcaNumber, form)));
            }

            // Wait for all validation promises to be resolved
            $q.all(validationPromises).then(
                function () {
                    deferred.resolve(user);
                },
                function (error) {
                    if (error.status == '400') {
                        deferred.reject(error);
                    }
                    else {
                        $exceptionHandler(error);
                    }
                }
            );

            return deferred.promise;
        }

        // Takes in a flagsViewmodel and validates that we have moved past the search view.
        // Returns true if valid, false otherwise.
        function validateAddressViewmodel(model) {
            return !(model.showSearch || model.searchError || model.noResultsFound || model.searching);
        }

        function setAddressRequiredValidity(form) {
            form.$setValidity('address-required', false);
        }

        function prepareSecurityQuestions(vm) {
            var securityQuestions = [];
            angular.forEach(vm.securityQuestions, function (question) {
                securityQuestions.push({ 'id': question.securityQuestion, 'value': question.securityAnswer })
            });
            return securityQuestions;
        }

        function validateFirm(fcaNumber, form) {
            var deferred = $q.defer();
            RegisterDataAccessService.verifyFirm(fcaNumber).then(function () {
                form.firmFcaNumber.$setValidity("duplicatefirm", false);
                deferred.reject({ data: 'Firm exists' });
            }, function (error) {
                if (error.status == 400) {
                    form.firmFcaNumber.$setValidity("duplicatefirm", false);
                    deferred.reject(error);
                }
                else if (error.status == 404) {
                    deferred.resolve();
                }
                else {
                    deferred.reject(error);
                }
            });

            return deferred.promise;
        }

        function populateUser(vm) {

            if (vm.firm.intermediaryType == vm.enums.RDIntermediaryType.directlyAuthorised &&
                vm.firm.principalFcaNumber != null) {
                vm.firm.principalFcaNumber = null;
            }

            if (vm.firm.intermediaryType == vm.enums.RDIntermediaryType.appointedRepresentative && vm.selectedPrincipalFirm != null) {
                vm.firm.principalFcaNumber = vm.selectedPrincipalFirm.fcaNumber;
            }

            var selectedRoles = vm.roles
                .filter(function (r) {
                    return r.checked;
                })
                .map(function (r) {
                    return { name: r.name }
                });

            var user = {
                title: parseInt(vm.user.title),
                forename: vm.user.forename,
                surname: vm.user.surname,
                dateOfBirth: moment(vm.user.dateOfBirth, moment.localeData().longDateFormat('L'),true).format('YYYY-MM-DDT00:00:00'),
                mobile: vm.user.mobileNumber,
                smsNotifications: vm.user.smsNotifications,
                telephone: vm.user.telephone,
                bdmRelationship: vm.user.bdmRelationship,
                emailAddress: vm.user.emailAddress,
                brokers: vm.firm.brokers,
                hasMarketingPreference: vm.user.hasMarketingPreference,
                areAdminsSentNotifications: vm.user.areAdminsSentNotifications,
                firm: {
                    fcaNumber: vm.firm.fcaNumber,
                    networkFcaNumber: vm.firm.networkFcaNumber,
                    principalFirmNumber: vm.firm.principalFcaNumber,
                    name: vm.firm.firmName,
                    mortgageClubs: getSelectedMortgageClubs(vm),
                    address: {
                        buildingNumber: vm.firmAddressViewModel.buildingNo,
                        buildingName: vm.firmAddressViewModel.buildingName,
                        flat: vm.firmAddressViewModel.flat,
                        street: vm.firmAddressViewModel.street,
                        district: vm.firmAddressViewModel.district,
                        town: vm.firmAddressViewModel.town,
                        county: vm.firmAddressViewModel.county,
                        postcode: vm.firmAddressViewModel.postcode
                    },
                    firmType: vm.firm.intermediaryType,
                    emailAddress: getFirmEmail(vm),
                    isSentNotifications: getIsSentNotifications(vm)
                },
                address: {
                    buildingNumber: vm.correspondenceAddressViewModel.buildingNo,
                    buildingName: vm.correspondenceAddressViewModel.buildingName,
                    flat: vm.correspondenceAddressViewModel.flat,
                    street: vm.correspondenceAddressViewModel.street,
                    district: vm.correspondenceAddressViewModel.district,
                    town: vm.correspondenceAddressViewModel.town,
                    county: vm.correspondenceAddressViewModel.county,
                    postcode: vm.correspondenceAddressViewModel.postcode
                },
                roles: selectedRoles,
                securityQuestions: prepareSecurityQuestions(vm),
                isPrincipal: vm.user.isPrincipal
            };
            //use firm read from find operation
            if (vm.findFirmSelected) {
                user.firm.address = vm.firm.address;
            }
            return user;
        }

        function populateBankDetails(vm) {

            var bankDetails = {};

            if (vm.firm && vm.firm.bankDetails) {
                bankDetails = {
                    accountNumber: vm.firm.bankDetails.accountNumber,
                    sortCode: vm.firm.bankDetails.sortCode,
                    accountHolder: vm.firm.bankDetails.accountHolder,
                    bankName: vm.firm.bankDetails.bankName ? vm.firm.bankDetails.bankName : null,
                    address: {
                        buildingNumber: vm.bankAddressViewModel.buildingNo,
                        buildingName: vm.bankAddressViewModel.buildingName,
                        flat: vm.bankAddressViewModel.flat,
                        street: vm.bankAddressViewModel.street,
                        district: vm.bankAddressViewModel.district,
                        town: vm.bankAddressViewModel.town,
                        county: vm.bankAddressViewModel.county,
                        postcode: vm.bankAddressViewModel.postcode
                    }
                }
            }

            return bankDetails;
        }

        function populateTradingAddress(vm) {

            var tradingAddress = {};

            if (vm.firm) {
                var capturedTradingAddress = vm.firmIsManual ? vm.tradingAddressAddressViewModel : vm.tradingAddress.address;
                tradingAddress = {
                    id: vm.tradingAddress.id,
                    bdm: vm.tradingAddress.bdm,
                    name: vm.tradingAddress.name,
                    address: {
                        buildingNumber: capturedTradingAddress.buildingNo ? capturedTradingAddress.buildingNo : capturedTradingAddress.buildingNumber,
                        buildingName: capturedTradingAddress.buildingName,
                        flat: capturedTradingAddress.flat,
                        street: capturedTradingAddress.street,
                        district: capturedTradingAddress.district,
                        town: capturedTradingAddress.town,
                        county: capturedTradingAddress.county,
                        postcode: capturedTradingAddress.postcode
                    }
                }
            }

            return tradingAddress;
        }

        function getSelectedMortgageClubs(vm) {

            if (!vm.findFirmSelected) {
                var selectedMortgageClubs;
                if (angular.isDefined(vm.allMortgageClubs)) {
                    selectedMortgageClubs = vm.allMortgageClubs.filter(function (mc) {
                        return mc.selected == true
                    });
                }

                return angular.isDefined(selectedMortgageClubs) ? selectedMortgageClubs : null;
            }

            //use firm read from find operation
            return vm.firm.mortgageClubs;
        }

        function getFirmEmail(vm) {
            if (vm.firm.emailAddress && vm.firm.emailAddress.length === 0) {
                vm.firm.emailAddress = null;
            }

            if (!vm.firm.isSentNotifications) {
                vm.firm.emailAddress = null;
            }

            return vm.firm.emailAddress;
        }

        function getIsSentNotifications(vm) {
            if (!vm.firm.isSentNotifications) {
                return vm.firm.isSentNotifications = false;
            }
            return vm.firm.isSentNotifications = true;
        }

    }
})();
